import { MY_PERMISSIONS_KEY } from '@/features/authentication/config/constants';
import { ApiHttpError, isForbidden, isRetryableApiError } from '@/shared/api/client';
import { toast } from '@/shared/lib/toast';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

function invalidateAuthorizationQueries(queryKey?: readonly unknown[]): void {
  if (queryKey?.[0] === MY_PERMISSIONS_KEY) return;
  void queryClient.invalidateQueries({ queryKey: [MY_PERMISSIONS_KEY] });
}

function handleQueryError(error: unknown, queryKey: readonly unknown[]): void {
  if (isForbidden(error)) invalidateAuthorizationQueries(queryKey);
}

function handleMutationError(error: unknown): void {
  if (!isForbidden(error)) return;
  invalidateAuthorizationQueries();
  toast.permissionDenied();
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => handleQueryError(error, query.queryKey),
  }),
  mutationCache: new MutationCache({ onError: handleMutationError }),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => failureCount < 1 && isRetryableApiError(error),
      retryDelay: (attempt, error) =>
        error instanceof ApiHttpError && error.retryAfterMs !== undefined
          ? error.retryAfterMs
          : Math.min(1_000 * 2 ** attempt, 30_000),
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
